/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date: Mon Nov 13 2023 16:52:39
 *
 *******************************************************/

// @flow

import React, { Component } from 'react';
import { TextStyle, Card, Layout, SkeletonBodyText, TextContainer } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  title: string,
  description: string,
  divider: boolean,
  isLoading: boolean
};

type ComposedProps = Props & WithI18nProps;

type State = {};

class SubSettings extends Component<ComposedProps, State> {
  state = {};

  componentDidMount() { }

  render() {
    const { isLoading = false, children, divider, title, description } = this.props;
    return (
        <div className="BC-SubSettings">
          <Layout>
            <Layout.Section oneThird>
              <TextStyle variation="strong">{title}</TextStyle>
              <div>
                <span className="SubSettings__description">{description}</span>
              </div>
            </Layout.Section>
            <Layout.Section>
              <Card sectioned>
                {isLoading ? (
                  <TextContainer>
                    <SkeletonBodyText lines={2} />
                  </TextContainer>
                ) : children 
                }
              </Card>
            </Layout.Section>
          </Layout>
          {divider && <div className="section-divider"></div>}
        </div>
    );
  }
}

export default withI18n()(SubSettings);
